import React, { InputHTMLAttributes } from 'react';
import { StyledInput } from './styles';

export type FieldDimensions = 'lg' | 'md' | 'sm';

export interface InputProps {
  placeholder?: string;
  error?: boolean | string;
  type?: string;
  dimension?: string;
  isButton?: boolean;
}

const TextInput: React.FC<InputProps & InputHTMLAttributes<HTMLInputElement>> = ({
  placeholder,
  type = 'text',
  error,
  dimension = 'lg',
  isButton,
  ...props
}) => (
  <StyledInput
    type={type}
    error={error}
    placeholder={placeholder}
    dimension={dimension}
    isButton={isButton}
    {...props}
  />
);

export default TextInput;
